import { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Spinner } from "@nextui-org/react";
import { apigetMonthlyDataDetails } from "../../services/apiCurrentAffairs/apicurrentaffairs";


export function MonthlyCurrentAffairsDetail() {
  const [loading, setLoading] = useState(true);
  const [affairs, setAffairs] = useState([]);
  const [month, setMonth] = useState("");
  const { monthParam } = useParams();
  const navigate = useNavigate();

const fetchMonthData = useCallback(async () => {
    if (!monthParam) return;

    const decoded = decodeURIComponent(monthParam);
    setMonth(decoded);
    setLoading(true);

    try {
        const res = await apigetMonthlyDataDetails(decoded);
        setAffairs(res.data || []);
    } catch (err) {
        console.error("Failed to load data:", err);
        setAffairs([]);
    } finally {
        setLoading(false);
    }
}, [monthParam]);

  useEffect(() => {
    fetchMonthData();
  }, [fetchMonthData]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });
  };

  return (
    <div className="max-w-[85rem] mx-auto py-5 px-4">
      <div className="flex items-center mb-6">
        <button onClick={() => navigate(-1)} className="mr-4">
          <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 className="text-3xl font-bold">{month} Current Affairs</h1>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <Spinner size="lg" color="primary" />
        </div>
      ) : affairs.length === 0 ? (
        <div className="py-16 text-center bg-gray-50 rounded-xl">
          <p className="text-gray-600">No current affairs found for {month}</p>
        </div>
      ) : (
        <>
          <div className="mb-8">
            <span className="inline-block px-4 py-2 text-sm font-medium text-blue-800 bg-blue-100 rounded-full">
              {affairs.length} {affairs.length === 1 ? "affair" : "affairs"} found
            </span>
          </div>

          <div className="space-y-6">
            {affairs.map((item) => (
              <div key={item._id} className="p-6 transition-shadow bg-white border border-gray-200 shadow-sm rounded-xl hover:shadow-md">
                <div className="flex flex-col gap-4 lg:flex-row lg:justify-between lg:items-start">
                  <div className="flex-1">
                    <h3 className="mb-3 text-xl font-bold text-blue-700">{item.Title}</h3>
                    <div className="flex flex-wrap items-center gap-3 text-sm text-gray-600">
                      <span>{formatDate(item.createdAt)}</span>
                      <span className="px-3 py-1 text-xs font-medium text-blue-800 bg-blue-100 rounded-full">
                        {item.Category}
                      </span>
                      <span className="px-3 py-1 text-xs font-medium text-green-800 bg-green-100 rounded-full">
                        {item.Current_Affair_Type}
                      </span>
                    </div>
                  </div>
                  <Link
                    to={`/current-affairs-detail/${item._id}`}
                    className="inline-block px-6 py-3 font-medium text-white transition bg-blue-600 rounded-lg hover:bg-blue-700 whitespace-nowrap"
                  >
                    Read More →
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}